module.exports = __webpack_public_path__ + "img/gateway.05b74c83.jpeg";